import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { getCoupons, deleteCoupon, reset } from '../../features/coupons/couponSlice'
import { useDispatch } from 'react-redux'
import { FaCheck, FaTimes } from "react-icons/fa";
import ButtonPrimary from '../../components/style-components/ButtonPrimary'
import { useNavigate } from 'react-router-dom'
import { exportCoupons } from '../../features/coupons/couponSlice'


function AdminEditCoupons() {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { coupons, total, page, limit, isLoading, isSuccess, isError, message } = useSelector(state => state.coupon)

    const { user } = useSelector((state) => state.auth);
    const [statusFilter, setStatusFilter] = useState('active');
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
      if (!user) {
        navigate('/');
      }
    }, [user, navigate]);

    useEffect(() => {
        if(isError){
            toast.error(message)
        }

        return () => {
            dispatch(reset())
        }
    }, [coupons, isLoading, isError, isSuccess, message])

    useEffect(() => {
        dispatch(getCoupons({ status: statusFilter, page: currentPage }));
    }, [dispatch, statusFilter, currentPage]);

    const handleExportCoupons = () => {
        dispatch(exportCoupons())
    }

    const handleFilterChange = (status) => {
        setStatusFilter(status);
        setCurrentPage(1);
    };

    const totalPages = useMemo(() => {
        const pages = Math.ceil((total || 0) / (limit || 50));
        return pages > 0 ? pages : 1;
    }, [total, limit]);

    useEffect(() => {
        if (page !== currentPage) {
            setCurrentPage(page);
        }
    }, [page, currentPage]);

    const goToPage = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    };

  return (
    <div className='edit-coupons'>
        <div className="flex padding-20-bottom gap-10">
            <ButtonPrimary text="Pievienot jaunu kuponu" onClick={() => navigate("/edit-coupons/new")}/>
            <ButtonPrimary text="Eksportēt visus kuponus" onClick={handleExportCoupons}/>
        </div>
        <div className="flex gap-10 padding-10-bottom">
            <ButtonPrimary text="Aktīvie kuponi" onClick={() => handleFilterChange('active')} disabled={statusFilter === 'active'}/>
            <ButtonPrimary text="Beigušies kuponi" onClick={() => handleFilterChange('expired')} disabled={statusFilter === 'expired'}/>
        </div>
        
        <table className="coupon-table">
            <thead>
                <tr>
                    <th style={{width:"20%", overflow:"hidden"}} className='coupon-code'>Kods</th>
                    <th style={{width:"15%"}} className='coupon-code'>Atlaide</th>
                    <th style={{width:"20%"}} className='coupon-code'>Kategorijas</th>
                    <th style={{width:"15%"}} className='coupon-code'>Bezmaksas piegāde</th>
                    <th style={{width:"15%"}}className='coupon-code'>Derīgs līdz </th>
                    <th style={{width:"15%"}}></th>
                </tr>
            </thead>
            <tbody>
                {coupons && coupons.map(coupon => (
                    <tr key={coupon._id}>
                        <td style={{width:"20%", overflow:"hidden"}} className='coupon-code'>{coupon.code}</td>
                        <td className='coupon-code'>{coupon.discountAmount ? `€${(coupon.discountAmount / 100).toFixed(2)}` : coupon.discountPercentage ? `${coupon.discountPercentage}%` : 'Bezmaksas piegāde'}</td>
                        <td className='coupon-code'>
                            {coupon.categories && coupon.categories.length > 0
                                ? coupon.categories.join(', ')
                                : coupon.products && coupon.products.length > 0
                                    ? 'Produkti'
                                    : 'Visi'}
                        </td>
                        <td className='coupon-code delivery'>{coupon.delivery ? <FaCheck /> : <FaTimes />}</td>
                        <td className='coupon-code'>
                            {!coupon.active || new Date(coupon.expiryDate).getTime() < new Date().getTime() ? "Nederīgs" : coupon.expiryDate.split('T')[0]}
                        </td>                        
                        <td className='coupon-code flex center gap-10'>
                           <ButtonPrimary text="Rediģēt" onClick={()=>navigate(`/edit-coupons/${coupon._id}`)}/>
                           <ButtonPrimary text="Dzēst" onClick={()=>dispatch(deleteCoupon(coupon._id))}/>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>

        <div className="coupon-pagination flex gap-10 padding-20-top">
            <ButtonPrimary text="Iepriekšējā" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}/>
            <span className='coupon-code'>Lapa {page} no {totalPages}</span>
            <ButtonPrimary text="Nākamā" onClick={() => goToPage(currentPage + 1)} disabled={currentPage >= totalPages}/>
        </div>

     
    </div>
  )
}

export default AdminEditCoupons
